const configErrors = {
  'user.firstName': {
    firstName: 'errors.firstNameIsNotMatchPattern',
  },
  firstName: {
    firstName: 'errors.firstNameIsNotMatchPattern',
  },
  'user.lastName': {
    lastName: 'errors.lastNameIsNotMatchPattern',
  },
  lastName: {
    lastName: 'errors.lastNameIsNotMatchPattern',
  },
  'user.alreadyAppliedToStation': {
    email: 'errors.emailExisting',
  },
  'user.emailAlreadyInUse': {
    email: 'errors.emailExisting',
  },
  'user.emailReserved': {
    email: 'errors.emailReserved',
  },
  'user.trainingModuleIds': {
    trainingModules: 'errors.trainingModuleIsRequired',
  },
};

export default configErrors;
